import { useMemo, useState } from "react";

import styles from "./Option.module.scss";
import { useIntl } from "react-intl";
import { MINER_POOLS } from "config";
import { IOptionProps } from "./Option.props";
import { usePoolTemplates } from "@utils/hooks/usePoolTemplates";
import { AutoComplete } from "antd";
import { Input } from "@components/global/new/Input/Input";
import { Select } from "@components/global/new/Select/Select";
import { IPoolCreds } from "@services/getSettings";
import { DEFAULT_SEPARATOR } from "@components/Pages/Settings/Settings.service";
import { AddressError, LoginError, PasswordError } from "@components/Pages/Settings/ErrorElemets";

// const ports: { [key: string]: number } = {
//   sha256: 8889,
//   scrypt: 8890,
//   basic: 8888,
//   equihash: 3890,
// };

function getPoolAddress(pool: IPoolCreds): string {
  const { extension } = JSON.parse(pool.props || "{}");
  if (!extension) return pool.address;
  return `${pool.address}#${extension}`;
}

// function getPoolErrorText(
//   poolWithCheck: PoolWithCheck
// ): string | null {
//   if (poolWithCheck.isFullEmpty || poolWithCheck.isCorrect) return null;
//   if (!poolWithCheck.isAddressCorrect) return "Address is incorrect";
//   if (poolWithCheck.needAddress) return "Address is required";
//   if (poolWithCheck.needLogin) return "Login is required";
//   if (poolWithCheck.needPassword) return "Password is required";
//   return null;
// }

export default function Option(props: IOptionProps) {

  if (!props.setting) return null;

  const { setting } = props;

  const { formatMessage } = useIntl();
  const templates = usePoolTemplates();

  const [address, setAddress] = useState("");

  const options = useMemo(() => {
    return templates
      .filter((t) => t.Address.includes(address))
      .map((temp) => ({
        label: temp.Address,
        value: temp.Address
      }));
  }, [address]);

  return (
    <div className={styles.option_wrapper}>
      <span>{formatMessage({ id: `settings.option.${props.optionNum}` })}</span>
      <div className={styles.option}>
        {props.showCase ? (
          <Input
            label={formatMessage({ id: "settings.option.address" })}
            type='text'
            id={`address_${props.optionNum}`}
            defaultValue={getPoolAddress(setting)}
            copyButton={props.showCase}
            onChange={(e) => setAddress(e.currentTarget.value)}
            error={<AddressError error={setting} />}
          />
        ) : (
          <label className={styles.name}>
            {formatMessage({ id: "settings.option.address" })}
            <AutoComplete
              options={options}
              defaultValue={getPoolAddress(props.setting)}
              id={`address_${props.optionNum}`}
              onSearch={(value) => setAddress(value)}
              className={styles.address}
              allowClear={false}
            />
            <AddressError error={setting} />
          </label>
        )}
        <Input
          label={formatMessage({ id: "settings.option.login" })}
          type='text'
          id={`login_${props.optionNum}`}
          defaultValue={props.setting.login}
          copyButton={props.showCase}
          error={<LoginError error={setting} />}
        />
        <Input
          label={formatMessage({ id: "settings.option.password" })}
          type='text'
          id={`password_${props.optionNum}`}
          defaultValue={props.setting.password}
          error={<PasswordError error={setting} />}
        />
        <Select
          label={formatMessage({ id: "settings.option.divider" })}
          style={{ width: "100%" }}
          id={`separator_${props.optionNum}`}
          defaultValue={props.setting.separator}
          options={[
            {
              value: DEFAULT_SEPARATOR,
              label: DEFAULT_SEPARATOR,
            },
            {
              value: "_",
              label: "_",
            },
          ]}
        />
      </div>
    </div>
  );
}
